<template>
  <jade-box
    :title="$t('tpvByBrandTitle')"
    hasPadding
    class="flex-1"
  >
    <template #action>
      <div class="flex items-center gap-1">
        <jade-switch
          @onClick="toogleType"
          name="brandsSwitch"
          disabledFocus
        />
        <jade-text>Valor em R$</jade-text>
      </div>
    </template>
    <template>
      <dash-card-content-fallback :hasData="hasData">
        <dash-progress-bar
          v-for="item in brands"
          :key="item.key"
          :value="item.percentage"
          :color="item.color"
          :currency="item.value"
          :show-currency="dataType === dataTypeEnum.VALUE"
        >
          <brand-icons :data-icon="item.leftIcon" />

          <jade-text>{{ $t(item.name) }}</jade-text>

          <brand-icons
            :data-icon="item.rightIcon"
            :dataType="dataType"
          />
        </dash-progress-bar>
      </dash-card-content-fallback>
    </template>
  </jade-box>
</template>

<script>
import { JadeBox, JadeText, JadeSwitch } from '@jade'

import Amplitude from '@/amplitude-events/resume.amplitude'
import { DASHBOARD_DATA_TYPE_ENUM } from '@/enums/dash-progress-data-type.enum'
import MathManager from '@/utils/math-manager.utils'

import DashProgressBar from '../components/DashProgressBar/index.vue'
import DashCardContentFallback from '../components/DashCardContentFallback/index.vue'
import DashProgressManager from '../dash-progress.manager'

import BrandsManager from './brands.manager'
import BrandIcons from './BrandTooltip.vue'

export default {
  name: 'Brands',
  components: {
    JadeBox,
    JadeText,
    JadeSwitch,

    DashProgressBar,
    DashCardContentFallback,

    BrandIcons
  },
  props: {
    data: Array
  },

  data () {
    return {
      dataTypeEnum: DASHBOARD_DATA_TYPE_ENUM,
      dataType: DASHBOARD_DATA_TYPE_ENUM.PERCENTAGE
    }
  },

  computed: {
    hasData () {
      return this.brands.length > 0
    },
    total () {
      return MathManager.sumByKeys(this.data)?.quantity ?? 0
    },
    brands () {
      return new BrandsManager( //
        new DashProgressManager(
          this.data, //
          this.total
        )
      ).get()
    }
  },

  methods: {
    toogleType () {
      this.dataType =
        this.dataType === DASHBOARD_DATA_TYPE_ENUM.PERCENTAGE
          ? DASHBOARD_DATA_TYPE_ENUM.VALUE
          : DASHBOARD_DATA_TYPE_ENUM.PERCENTAGE

      Amplitude.events.filters.brandsTypeValueChanged({
        type: this.dataType
      })
    }
  }
}
</script>

<i18n>
{
  "pt-BR": {
    "tpvByBrandTitle": "Bandeiras mais utilizadas",
    "tpvByBrandDescription": "Total do TPV capturado por bandeira de cartão."
  },
  "en-US": {
    "tpvByBrandTitle": "Most used brands",
    "tpvByBrandDescription": "Total TPV captured by each card Brand."
  }
}
</i18n>
